import { Injectable } from '@angular/core';
import { StageService } from '../services/stage.service';

declare let THREE: any;

@Injectable()
export class HeightValidatorService {

  constructor(
    private stageService: StageService
  ) { }


  private getTiersHeight(): any {
    let heightValues = this.stageService.getCompoundFloor().children.map(element => element.getWorldPosition(new THREE.Vector3()).y);
    Math.max.apply(null, heightValues) - Math.min.apply(null, heightValues);
    return heightValues;
  }

  public getMinHeight(): number {
    let heightValues = this.getTiersHeight();
    return heightValues[0] - Math.min.apply(null, heightValues) + 20.32;
  }

  checkDecrFeet() {
    const oneFeetInCm = 30.48;
    let heightValues = this.getTiersHeight();
    if (heightValues.every(function (element) { return (element - oneFeetInCm) >= 20.3; })) {
      return true;
    }
    else {
      return false;
    }
  }

  checkDecrInch() {
    let oneInchInCm = 2.54;
    let heightValues = this.getTiersHeight();
    if (heightValues.every(function (element) { return (element - oneInchInCm) >= 20.32; })) {
      return true;
    }
    else {
      return false;
    }
  }

  checkChangeHeightValidate(feetInput, inchInput): boolean {
    let heightInput = feetInput * 30.48 + inchInput * 2.54;
    let minHeight = this.getMinHeight();
    if (heightInput >= minHeight) {
      return true
    }
    else {
      return false
    }
  }



}



// WEBPACK FOOTER //
// ./src/app/services/height-validator.service.ts